<template>
	<div>

		<!-- <el-button type="primary" @click="">添加</el-button> -->
		<el-card>
			<div>
				<!-- <el-input v-model="input" placeholder="请输入内容"></el-input> -->
				<el-date-picker :unlink-panels="true" @change="getDate" value-format="yyyy-MM-dd" v-model="date1"
					type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
				</el-date-picker>
			</div>
			<el-table :data="tableData" border style="width: 100%;" height="750">
				<el-table-column type="index" label="序号" width="60">
				</el-table-column>
				<el-table-column prop="pushTime" label="发送时间" width="180">
				</el-table-column>
				<el-table-column prop="sender" label="发送人" width="180">
				</el-table-column>
				<el-table-column prop="receiver" label="接收人" width="180">
				</el-table-column>

				<el-table-column prop="templateName" label="模板名称">
				</el-table-column>
				<el-table-column prop="json" label="消息详情">
				</el-table-column>
				<el-table-column prop="type" label="类型" width="180">
				</el-table-column>
				<el-table-column prop="result" label="发送结果">
					<template slot-scope="scope">
						<span v-if="scope.row.result == 'ok'">成功</span>
						<span v-else>失败：原因-{{scope.row.result}}</span>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
	</div>
</template>

<script>
import cx from '../api/xxcx'
import zt from '../api/zt'
export default {
  name: 'xxcx',
  data() {
    return {
      ztid: 0,
      tableData: [],
      ztlist: [],
      admin: '',
      date1: [],
      form: {
        ksrq: '',
        jsrq: '',
        ztid: sessionStorage.getItem('ztid'),
        zt: sessionStorage.getItem('ztmc') || ''
      }
    }
  },
  methods: {
    // 格式化日期为 yyyy-MM-dd
    formatDate(date) {
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      return `${year}-${month}-${day}`
    },
    // 获取当月第一天
    getMonthStart() {
      const now = new Date()
      const start = new Date(now.getFullYear(), now.getMonth(), 1)
      return this.formatDate(start)
    },
    // 获取当月最后一天
    getMonthEnd() {
      const now = new Date()
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
      return this.formatDate(end)
    },
    async getzt() {
      this.ztlist = []
      let res = await zt.getAllzt()
      this.ztlist = res.data.data
    },
    async queryAllPushRecordInfo() {
      console.log('全部记录查询参数：', this.form)
      const { data: res } = await cx.queryAllPushRecordInfo(this.form)
      this.tableData = res.data
    },
    async queryPushRecordInfoByZtid() {
      console.log('站点过滤查询参数：', this.form)
      const { data: res } = await cx.queryPushRecordInfoByZtid(this.form)
      this.tableData = res.data
    },
    getDate(e) {
      this.form.ksrq = e[0]
      this.form.jsrq = e[1]
      this.ifAdmin()
      console.log('选择日期后：', e)
    },
    ifAdmin() {
      if (this.admin != "admin") {
        this.queryPushRecordInfoByZtid()
      } else {
        this.queryAllPushRecordInfo()
      }
    }
  },
  mounted() {
    const ztid = sessionStorage.getItem('ztid')
    const dm = sessionStorage.getItem("dm")
    this.ztid = ztid
    this.admin = dm
    this.form.ztid = ztid

    // 初始化起止日期 yyyy-MM-dd
    const start = this.getMonthStart()
    const end = this.getMonthEnd()
    this.date1 = [start, end]
    // 统一走getDate赋值表单并请求接口，和手动选日期逻辑一致
    this.getDate([start, end])
  }
}
</script>

<style>
</style>